import React from 'react';

import { gray5 } from 'utils/color-styles';

interface TabItemProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> {
  children?: React.ReactNode;
  isActive?: boolean;
}

const TabItem = ({ children, isActive, ...rest }: TabItemProps) => {
  const normal = {
    color: gray5,
    fontWeight: 400,
    fontSize: 14,
    marginTop: 15,
    marginBottom: 0,
    marginRight: 25,
    paddingBottom: 14,
    cursor: 'pointer',
  };
  const active = {
    ...normal,
    ...{
      color: '#1E1F20',
      borderBottom: '1px solid #1E1F20',
      fontWeight: 500,
    },
  };

  return (
    <span style={isActive ? active : normal} {...rest}>
      {children}
    </span>
  );
};

export default TabItem;
